import { render, staticRenderFns } from "./SystemRoleTable.vue?vue&type=template&id=6dc60126&"
import script from "./SystemRoleTable.vue?vue&type=script&lang=js&"
export * from "./SystemRoleTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports